/**
 * Custom validation resolvers for tax-period compose form.
 * Loaded at app startup via `bootstrapBlockRegistry` glob — do not import from actions/pages.
 */
import { parseDateLocal } from '@packages/core';
import { ResolverRegistry } from '@packages/form-engine';
import type { ConditionContext } from '@packages/form-engine';

function compareEffectiveDates(
  from: unknown,
  till: unknown,
): { fromTime: number; tillTime: number } | null {
  if (from == null || till == null) return null;
  const fromStr = String(from).trim();
  const tillStr = String(till).trim();
  if (fromStr === '' || tillStr === '') return null;

  const fromTime = parseDateLocal(fromStr).getTime();
  const tillTime = parseDateLocal(tillStr).getTime();
  if (Number.isNaN(fromTime) || Number.isNaN(tillTime)) return null;

  return { fromTime, tillTime };
}

/** Start must not be after end (same calendar day allowed — legacy Yup parity). */
ResolverRegistry.registerValidation(
  'taxPeriodStartBeforeEnd',
  (_value: unknown, formData: Record<string, unknown>, _ctx: ConditionContext) => {
    const compared = compareEffectiveDates(formData.effectiveFrom, formData.effectiveTill);
    if (compared == null) return null;
    if (compared.fromTime > compared.tillTime) {
      return 'Start date must be before end date';
    }
    return null;
  },
);

ResolverRegistry.registerValidation(
  'taxPeriodEndAfterStart',
  (_value: unknown, formData: Record<string, unknown>, _ctx: ConditionContext) => {
    const compared = compareEffectiveDates(formData.effectiveFrom, formData.effectiveTill);
    if (compared == null) return null;
    if (compared.tillTime < compared.fromTime) {
      return 'End date must be after start date';
    }
    return null;
  },
);
